import { PaymentDetails } from "../../Model/index";

export class PaymentDetailsDataContainer {
    PaymentDetails: PaymentDetails[] = [];
    TotalAmount: string;
    sessionExpiry: boolean;
    SessionTimeout: string;
    isValid: string;
    transaction_id: string;
    PayAmount: string;
    PatientId: string;
    ReceiptNo: string;
    result: string;
    PatientName: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/model/booking/PaymentDetailsDataContainer.ts